import { Page } from '@types';
import { Http } from './http';

class PageHttp extends Http {
  prefix = 'page';

  async publishNewVersion(pageId: number): Promise<Page> {
    const res = await this.post<Page>(`/${pageId}/publish-version`);

    return res.data;
  }
}

export const pageHttp = new PageHttp();
